import { render, staticRenderFns } from "./AppCompany.vue?vue&type=template&id=3fbd5b94&scoped=true&"
import script from "./AppCompany.vue?vue&type=script&lang=js&"
export * from "./AppCompany.vue?vue&type=script&lang=js&"
import style0 from "./AppCompany.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AppCompany.vue?vue&type=style&index=1&id=3fbd5b94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbd5b94",
  null
  
)

/* custom blocks */
import block0 from "./AppCompany.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./AppCompany.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VCol,VContainer,VFooter,VMain,VRow})
